/**
 * Les categories del cas, segons el seu marc d'anàlisi.
 *
 * Cada cas té un `category_system` (PESTEL per defecte) i, si és CUSTOM, una
 * llista pròpia. Aquesta funció és la mateixa lògica que ja fa servir el mapeig
 * estratègic; s'ha tret aquí perquè el backcasting no en fos una tercera còpia.
 *
 * Rep `t` en comptes de cridar useTranslation perquè així es pot fer servir
 * tant dins d'un useMemo com fora de cap component.
 */
export const categoriesDelCas = (case_, t) => {
  const sistema = case_?.category_system || 'PESTEL';

  if (sistema === 'CUSTOM' && case_?.custom_categories?.length) {
    return case_.custom_categories.map(c => ({ value: c, label: c }));
  }

  const perSistema = {
    PESTEL: ['political', 'economic', 'social', 'technological', 'environmental', 'legal'],
    SWOT: ['strengths', 'weaknesses', 'opportunities', 'threats'],
    CYBER: ['identify', 'protect', 'detect', 'respond', 'recover']
  };
  const claus = perSistema[sistema] || perSistema.PESTEL;
  const prefix = { PESTEL: 'pestel', SWOT: 'swot', CYBER: 'cyber' }[sistema] || 'pestel';

  return claus.map(c => ({ value: c, label: t(`factors.${prefix}.${c}`) }));
};

export default categoriesDelCas;
